import React from 'react';
import './styles.css';

import MetricsDisplay from '../../components/metrics/MetricsDisplay';

const Metrics = () => {
  return (
    <div className="metrics-page">
      <MetricsDisplay />
    </div>
  );
};

export default Metrics;